var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("p", {
        staticClass: "icon-jujue closeBtn",
        on: { click: _vm.routerBack },
      }),
    ]),
    _c("div", { staticClass: "content_box" }, [
      _c("div", { staticClass: "within_box" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "form_box" },
          [
            _c(
              "el-form",
              {
                ref: "detailForm",
                attrs: {
                  model: _vm.detailForm,
                  rules: _vm.rules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "SR编号", prop: "srNumber" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.detailForm.srNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "srNumber", $$v)
                                },
                                expression: "detailForm.srNumber",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "回收启动日期",
                              prop: "recoveryStartDate",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.detailForm.recoveryStartDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailForm,
                                    "recoveryStartDate",
                                    $$v
                                  )
                                },
                                expression: "detailForm.recoveryStartDate",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "回收项目简介",
                              prop: "recoveryProjectSummary",
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.detailForm.recoveryProjectSummary,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailForm,
                                    "recoveryProjectSummary",
                                    $$v
                                  )
                                },
                                expression: "detailForm.recoveryProjectSummary",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "已结案", prop: "isClosed" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.detailForm.isClosed,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailForm, "isClosed", $$v)
                                  },
                                  expression: "detailForm.isClosed",
                                },
                              },
                              _vm._l(_vm.isClosedLists, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "SR等级", prop: "srGrade" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { disabled: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.detailForm.srGrade,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailForm, "srGrade", $$v)
                                  },
                                  expression: "detailForm.srGrade",
                                },
                              },
                              _vm._l(_vm.srGradeLists, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "发起人", prop: "createBy" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.detailForm.createBy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "createBy", $$v)
                                },
                                expression: "detailForm.createBy",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态", prop: "status" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                table: "TT_QSPI_STOCK_REC_HEADER",
                                field: "STATUS",
                              },
                              model: {
                                value: _vm.detailForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "status", $$v)
                                },
                                expression: "detailForm.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "原因", prop: "reason" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                type: "textarea",
                                maxlength: "100",
                                "show-word-limit": "",
                                autosize: { minRows: 4, maxRows: 6 },
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailForm.reason,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "reason", $$v)
                                },
                                expression: "detailForm.reason",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注", prop: "remarks" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                type: "textarea",
                                maxlength: "100",
                                "show-word-limit": "",
                                autosize: { minRows: 4, maxRows: 6 },
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailForm.remarks,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailForm, "remarks", $$v)
                                },
                                expression: "detailForm.remarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "tab_box" },
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "border-card" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "产品明细", name: "tab1" } },
                [
                  _c(
                    "ux-grid",
                    {
                      ref: "plxTable1",
                      attrs: {
                        data: _vm.tableData1,
                        "keep-source": "",
                        "max-height": "500",
                        "show-overflow": "tooltip",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "序号",
                          type: "index",
                          width: "60",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "产品编号",
                          field: "eightBitCode",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "产品名称",
                          field: "eightBitCodeName",
                          "min-width": "100",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "结算单位名称",
                          field: "supplierName",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "Facility名称",
                          field: "facilityName",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "产品批次",
                          field: "batchNo",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "涉及DCs",
                          field: "relatedDcName",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "Regions",
                          field: "regoins",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "回收范围",
                          field: "recoveryScopeI18n",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "餐厅回收数量(箱)",
                          field: "restaurantRecoveryQty",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "DC回收数量(箱)",
                          field: "dcRecoveryQty",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "回收数量(箱)",
                          field: "recoveryQty",
                          "min-width": "120",
                        },
                      }),
                      _c("ux-table-column", {
                        attrs: {
                          align: "center",
                          title: "处理结果",
                          field: "handlingResultI18n",
                          "min-width": "120",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "附件上传", name: "tab2" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "plxTable2",
                      attrs: {
                        data: _vm.tableData2,
                        "max-height": "500",
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "附件大类",
                          prop: "attachmentLargeCategory",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "附件子类",
                          prop: "attachmentSmallCategory",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "附件名称",
                          prop: "fileName",
                          "show-overflow-tooltip": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDownload(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.fileName))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "上传人",
                          prop: "uploadBy",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "上传时间",
                          prop: "uploadTime",
                          "show-overflow-tooltip": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "操作日志", name: "tab3" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "plxTable3",
                      attrs: {
                        data: _vm.tableData3,
                        "max-height": "500",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "操作时间",
                          prop: "operateTime",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "操作人",
                          prop: "operateBy",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "操作描述",
                          prop: "operateDesc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title_box" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "title" }, [_vm._v("Case Detail")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }